import { render } from "./TheSymbolCollection.vue?vue&type=template&id=bd858f0c&scoped=true&ts=true"
import script from "./TheSymbolCollection.vue?vue&type=script&lang=ts"
export * from "./TheSymbolCollection.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd858f0c"]])

export default __exports__